import React from "react";
import { GoldLogo } from "../ItemCard";
import ItemTemp from "@outplayed/tooltips/src/tooltipImages/ItemTemp";

const ItemStatsRecipe = (props) => {
  const { itemId, itemData } = props;

  if (!itemId || !itemData) return null;

  const from = itemData.from;

  const plusIcon = "https://static.bigbrain.gg/assets/ugg/icons/plus.svg";

  return (
    <div className="items-details-section">
      <div className="items-header">Recipe</div>
      {from && (
        <div className="stats-recipe-components">
          {from?.map((id, index) => (
            <div className="recipe-img-container" key={`${id}-${index}`}>
              <ItemTemp itemId={id} className="recipe-img items-pic-30 items-border-normal-small" enableLink={true} />
              <img src={plusIcon} alt="" className="plus-icon" />
            </div>
          ))}
          <GoldLogo cost={itemData.gold?.base} />
        </div>
      )}

      <div className="stats-recipe-info">
        <div className="stats-recipe-data">
          <span className="recipe-title">Cost</span>
          <GoldLogo cost={itemData.gold?.total} />
        </div>
        <div className="stats-recipe-data">
          <span className="recipe-title">Sell</span>
          <GoldLogo cost={itemData.gold?.sell} />
        </div>
        <div className="stats-recipe-data">
          <span className="recipe-title">ID</span>
          <span>{itemId}</span>
        </div>
      </div>
    </div>
  );
};

export default ItemStatsRecipe;
